module.exports = __webpack_public_path__ + "img/11825392_L.4e1baefd.png";